import { useState } from 'react';
import { ResetDialog } from '../components/ui/ResetDialog';
import { CategoriesManager } from '../components/ui/CategoriesManager';
import { useToast } from '../components/ui/ToastContext';

export function SettingsPage() {
  const { showToast } = useToast();
  const [isResetDialogOpen, setIsResetDialogOpen] = useState(false);

  const handleSuccess = (message: string) => showToast(message, 'success');
  const handleError = (message: string) => showToast(message, 'error');

  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6">
      <h1 className="text-2xl font-bold text-near-black mb-6">Ajustes</h1>

      <div className="space-y-6">
        <section className="bg-white rounded-lg shadow p-6">
          <CategoriesManager onSuccess={handleSuccess} onError={handleError} />
        </section>

        <section className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold text-near-black mb-4">
            Gestion de datos
          </h2>

          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 bg-red-50 border border-red-200 rounded-lg">
              <div>
                <h3 className="font-medium text-near-black">Reiniciar datos</h3>
                <p className="text-sm text-mid-gray">
                  Elimina todas las transacciones, presupuestos y correcciones.
                </p>
              </div>
              <button
                onClick={() => setIsResetDialogOpen(true)}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition min-h-[44px]"
              >
                Reiniciar
              </button>
            </div>
          </div>
        </section>

        <section className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold text-near-black mb-4">
            Informacion
          </h2>
          <div className="space-y-2 text-sm text-mid-gray">
            <p>
              <strong>Budgeter</strong> - Finanzas personales en tu dispositivo
            </p>
            <p>
              Tus datos se almacenan localmente en tu navegador. Usa las
              opciones de Exportar e Importar en el menu para hacer copias de
              seguridad.
            </p>
          </div>
        </section>
      </div>

      <ResetDialog
        isOpen={isResetDialogOpen}
        onClose={() => setIsResetDialogOpen(false)}
        onSuccess={handleSuccess}
        onError={handleError}
      />
    </div>
  );
}
